import type * as React from 'react'

// NOTE (Phase 00 contract gap, still open): reference/ICON-NORMALISATION.md §(c) specifies a
// shared `SvgIconProps` from './types.ts'. That file has no owning task in any phase file yet
// (flagged in PHASE-00's Notes as an open gap). This component must not create `./types.ts`
// unprompted, so the prop type is inlined here rather than imported. Once `./types.ts` exists,
// this local type should be replaced with an import from it to match every other icon component.
type SvgIconProps = Omit<React.SVGProps<SVGSVGElement>, 'children'> & {
  /** Accessible name. Omit for a purely decorative icon (default: aria-hidden). */
  title?: string
  /** Rendered size in px. Defaults to 16 — the artwork's native/authored size. */
  size?: 12 | 16
}

// D-ICON-1 (2026-08-25): the 12px and 16px `Chevron Down` exports were measured
// coordinate-by-coordinate (40 coordinates compared) and found to be a uniform 4/3 scale of one
// another, ratio spread 0.000092 — equal to within float rounding. Per the owner decision this
// single component keeps the 16px artwork and viewBox (more coordinate precision than the 12px
// export) and lets the `size` prop drive only the rendered width/height attributes; the viewBox
// stays "0 0 16 16" regardless of `size`, so the 12px render is the SVG user agent uniformly
// scaling this same path data by 12/16 — mathematically identical to what the separate 12px
// artwork was (the two differed only by that same uniform scale).
export function IconChevronDown({ title, size = 16, ...rest }: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M12.4702 5.46991C12.7631 5.17702 13.2372 5.17702 13.5301 5.46991C13.8229 5.76281 13.8229 6.23692 13.5301 6.52981L8.53005 11.5298C8.23716 11.8227 7.76305 11.8227 7.47016 11.5298L2.47016 6.52981C2.17726 6.23692 2.17726 5.76281 2.47016 5.46991C2.76305 5.17702 3.23716 5.17702 3.53005 5.46991L8.00011 9.93997L12.4702 5.46991Z"
        fill="currentColor"
      />
    </svg>
  )
}
